export const PAPER_UPLOAD_STATES = {
  start: 'start' as const,
  end: 'end' as const,
}

export const EVENT_TYPES = {
  PAGEVIEW: 'pageview' as const,
  PAPER_UPLOAD: 'paper_upload' as const,
  CLICKSTREAM_VIEW: 'clickstream_view' as const,
}

export const ALLOCATION_MAP_KEY = 'allocationMap'

export const PAGE_TYPE = 'upload lp'
